export const getLisboaData = () => ({
  name: "Lisboa",
  country: "Portugal",
  description: "Lisboa est une vaste région côtière produisant une grande diversité de vins, des blancs frais aux rouges puissants, en passant par les vins doux de Carcavelos.",
  type: "region",
  subregions: [
    { name: "Colares", area: "1,000 ha", percentage: "6%", description: "Vins de sable, cépage Ramisco" },
    { name: "Bucelas", area: "1,500 ha", percentage: "9%", description: "Blancs de Arinto" },
    { name: "Óbidos", area: "2,000 ha", percentage: "12%", description: "Vins doux et mousseux" },
    { name: "Alenquer", area: "2,500 ha", percentage: "15%", description: "Rouges puissants" },
    { name: "Arruda", area: "1,500 ha", percentage: "9%", description: "Rouges fruités" },
    { name: "Torres Vedras", area: "2,000 ha", percentage: "12%", description: "Vins variés" },
    { name: "Lourinhã", area: "1,000 ha", percentage: "6%", description: "Eaux-de-vie AOC" },
    { name: "Encostas d'Aire", area: "2,000 ha", percentage: "12%", description: "Vins de terroir" },
    { name: "Carcavelos", area: "1,000 ha", percentage: "6%", description: "Vins doux historiques" }
  ],
  mapAreas: [
    { region: "Colares", x: 49, y: 52, color: "#4B164C", size: 2 },
    { region: "Bucelas", x: 51, y: 54, color: "#6d2c7a", size: 2 },
    { region: "Óbidos", x: 53, y: 56, color: "#8a4a8a", size: 3 },
    { region: "Alenquer", x: 55, y: 58, color: "#a768a6", size: 3 },
    { region: "Arruda", x: 57, y: 60, color: "#c486c4", size: 2 },
    { region: "Torres Vedras", x: 59, y: 62, color: "#e2a4e2", size: 2 },
    { region: "Lourinhã", x: 61, y: 64, color: "#f0c2f0", size: 2 },
    { region: "Encostas d'Aire", x: 63, y: 66, color: "#f8e0f8", size: 2 },
    { region: "Carcavelos", x: 65, y: 68, color: "#4B164C", size: 2 }
  ],
  statistics: {
    totalArea: "18,000 ha",
    production: "600,000 hl",
    wineries: "120+ domaines",
    appellations: "9 sous-régions",
    exportPercentage: "18%"
  },
  characteristics: {
    climate: "Climat atlantique tempéré, brumes côtières fréquentes",
    soil: "Sols sableux, argilo-calcaires, calcaires, sables de Colares",
    viticulture: "Vignes franches de pied à Colares, diversité de cépages"
  },
  wineStyles: {
    red: "Rouges variés, du fruité au puissant",
    white: "Blancs frais, Arinto, Fernão Pires",
    sweet: "Vins doux historiques de Carcavelos"
  },
  history: "Lisboa (ex-Estremadura) est une région historique, exportant ses vins vers l'Angleterre dès le XVIIIe siècle. Colares est célèbre pour ses vignes pré-phylloxériques.",
  foodPairing: "Poissons grillés, fruits de mer, fromages locaux, pâtisseries de Lisbonne"
}); 